angular.module('property-deal')
    .controller('PropertyDealAddExtraChargeController', function ($uibModalInstance, data, Project, Property, PropertyService) {
        this.PropertyService = PropertyService
        this.$onInit = () => {
            this.attributes = Project.attributes({id: data.projectId});
            this.calculationMethods = Property.calculationMethods();

            this.item = {
                name: null,
                type: 'EXTRA_CHARGE',
                calculationMethod: 'TOTAL_GROSS',
                calculationBasedOn: 'TOTAL',
                vat: null,
                pricing: {}
            }
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return $uibModalInstance.close(this.item);
        }
    })
